// extracted by mini-css-extract-plugin
export default {"root":"IconCheckMark_root__gOleC"};